var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUpdate(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 21,
    height: 21,
    rx: 10.5,
    stroke: "#CBCBCB"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7,
    clipPath: "url(#clip0_13751_125723)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.5 11C16.5 11.521 16.423 12.0225 16.2875 12.5H15.237C15.4045 12.03 15.5 11.5265 15.5 11C15.5 8.519 13.4815 6.5 11 6.5C10.147 6.5 9.352 6.742 8.6725 7.157L9.6015 8.5H6.1045L7.1805 5L8.105 6.3365C8.947 5.812 9.9345 5.5 11 5.5C14.037 5.5 16.5 7.9625 16.5 11ZM13.323 14.846C12.6445 15.259 11.851 15.5 11 15.5C8.519 15.5 6.5 13.481 6.5 11C6.5 10.4735 6.5955 9.97 6.7625 9.5H5.7125C5.577 9.9775 5.5 10.479 5.5 11C5.5 14.0375 7.9625 16.5 11 16.5C12.0635 16.5 13.0495 16.1895 13.89 15.6665L14.8165 17L15.8925 13.5055H12.3955L13.323 14.846Z",
    fill: "#55595F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13751_125723"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(5 5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpdate);
export default __webpack_public_path__ + "static/media/update.e2e78f20a10e9e6a27f1aac7b4a1250b.svg";
export { ForwardRef as ReactComponent };